<template>
  <div class="btn">
    <el-button :type="activeTab === data.id ? 'primary' : ''" @click="onTabClick">
      <slot></slot>
    </el-button>

    <i class="btn-icon access el-icon-success" v-if="data.filled"></i>
    <i class="btn-icon waiting el-icon-time" v-else></i>
    <i class="btn-icon remove el-icon-error" v-if="lens > 1" @click.stop="onRemove"></i>
  </div>
</template>
<script>
export default {
  inject: ['getParent'],
  props: {
    data: Object
  },
  computed: {
    activeTab() {
      return this.$parent.activeTab
    }
  },
  data() {
    return {
      lens: this.getParent.$slots.default?.length || 0
    }
  },
  updated() {
    this.lens = this.getParent.$slots.default.length
  },
  methods: {
    onTabClick() {
      const { childChange, beforeChange, value } = this.getParent
      if (this.data.id !== value) {
        if (beforeChange && typeof beforeChange === 'function') {
          beforeChange()
            .then(() => {
              childChange(this.data.id)
            })
            .catch((e) => {})
        } else {
          childChange(this.data.id)
        }
      }
    },
    onRemove() {
      this.getParent.removeChange(this.data.id)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';

@mixin icon {
  position: absolute;
  z-index: 1;
  font-size: 16px;
  top: -8px;
  color: $red;
}
.btn {
  position: relative;
  margin-right: 20px;
  margin-bottom: 6px;

  .btn-icon {
    background: #fff;
    border-radius: 100px;
  }
  .remove {
    @include icon;
    left: -8px;
    cursor: pointer;
  }
  .access,
  .waiting {
    @include icon;
    right: -8px;
  }

  .access {
    color: $green;
  }
}
</style>
